import React from 'react';
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

const LongText = ({ question, answers, dispatch }) => {
  const answer = answers.find((answer) => {
    return answer.linkId === question.linkId
  });

  return <>
    <h6 className="card-title">{question.linkId}. {question.text || 'Enter your question.'}</h6>

    <textarea
      defaultValue={answer ? answer.answer : ''}
      onChange={(e) => { dispatch(answerQuestion(question, e.target.value)) }}
      className="form-control" rows="3"></textarea>
  </>;
}

const mapStateToProps = state => {
  return {
    answers: state.questionnaire.answers
  }
}

export default connect(mapStateToProps)(LongText);